import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/warloc-icon.png")